import { DependencyList, EffectCallback, useEffect, useRef } from 'react';

/**
 * Accepts a function that contains imperative, possibly effectful code,
 * but will not be executed on the first render.
 *
 * @param effect Imperative function that can return a cleanup function
 * @param deps If present, effect will only activate if the values in the list change.
 */
export function useEffectSkipFirst(effect: EffectCallback, deps?: DependencyList) {
    const firstRender = useRef(true);

    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(firstRender.current ? () => undefined : effect, deps);

    firstRender.current = false;
}
